const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class ShoeFinderFacts extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
    this.startAutoSlideTimer()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slides: {
          perView: 1,
          spacing: 0,
        },
        slideChanged: this.onSlideChanged,
      },
      [setInitialised()],
    )
  }

  onSlideChanged (instance) {
    this.updateCurrentSlide(instance)
    this.resetAutoSlideTimer()
  }

  updateCurrentSlide (instance) {
    const currentSlide = instance.track.details.rel

    this.els?.slide?.elements?.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })

    this.els.index.element.innerText = currentSlide + 1
  }

  startAutoSlideTimer () {
    this.startTime = performance.now()
    this.timerFrame = null

    const animate = (currentTime) => {
      const elapsed = currentTime - this.startTime
      const progress = Math.min(elapsed / this.timerDurationSeconds, 1)

      this.els.timer.element.style.width = `${progress * 100}%`

      if (progress < 1) {
        this.timerFrame = requestAnimationFrame(animate)
      } else {
        this.carousel.next()
        this.startAutoSlideTimer()
      }
    }

    this.timerFrame = requestAnimationFrame(animate)
  }

  resetAutoSlideTimer () {
    if (this.timerFrame) cancelAnimationFrame(this.timerFrame)
    if (this.els.timer?.element) {
      this.els.timer.element.style.width = '0%'
    }
    this.startTime = performance.now()
    this.timerFrame = requestAnimationFrame(
      this.startAutoSlideTimer.bind(this),
    )
  }

  get timerDurationSeconds () {
    return 8000
  }
}

if (!customElements.get('shoe-finder-facts')) {
  customElements.define('shoe-finder-facts', ShoeFinderFacts)
}
